import { takeLatest, select, call, put } from "redux-saga/effects";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import { requestDefaultJson } from './helpers'
import convertBase64 from '../../helpers/convertBase64'
import messages from "../../assets/i18n";
import axios from "axios";

const originCertificateList = (payload, token) => {
    const { page, filters } = payload
   
    const urlFilters =
        addFilter(filters.codigo, 'codigo') +
        addFilter(filters.pedido, 'pedido') +
        addFilter(filters.dtPedidoInicial, 'dtPedidoInicial') +
        addFilter(filters.dtPedidoFinal, 'dtPedidoFinal') +
        addFilter(filters.dtAtualizacaoInicial, 'dtAtualizacaoInicial') +
        addFilter(filters.dtAtualizacaoFinal, 'dtAtualizacaoFinal')
        
    return requestDefaultJson({
        URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/certificado-origem?currentPage=' + page + '&perPage=20' + urlFilters,
        method: "GET",
        headers: {
          "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CERTIFICADO_ORIGEM"),
          "Authorization": token,
        }
      })
};

const originCertificateData = (payload, token) => {
    const { id } = payload
      
    return requestDefaultJson({
        URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/certificado-origem/' + id,
        method: "GET",
        headers: {
          "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CERTIFICADO_ORIGEM"),
          "Authorization": token,
        }
      })
};

const originCertificateFile = (payload, token) => {
    const { id } = payload
      
    return requestDefaultJson({
        URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/certificado-origem/download/' + id,
        method: "GET",
        headers: {
          "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CERTIFICADO_ORIGEM"),
          "Authorization": token,
        }
      })
};


const uploadFile = (payload, file, token) => {
    const { orderId, code } = payload.fileDetails

	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + '/certificado-origem', {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CERTIFICADO_ORIGEM"),				
				"Authorization": token
			},
            data: {
                order: orderId,
                codigo: code,
                file: file
            }
		    })
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				const response = error.response.data
				reject(response);
				log.info(error);
			});
	});
};

const editUploadFile = (payload, file, token) => {
    const { id, code } = payload.fileDetails

	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + '/certificado-origem/' + id, {
			method: "PUT",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CERTIFICADO_ORIGEM"),				
				"Authorization": token
			},
            data: {
                id: id,
                codigo: code,
                file: file
            }
		    })
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				const response = error.response.data
				reject(response);
				log.info(error);
			});
	});
};

const addFilter = (filter, filterName) => {
	if (filter) {
		return '&' + filterName + '=' + filter
	} else {
		return ''
	}
}


function* getOriginCertificateList({payload}) {
	try {
		const { token } = yield select(state => state.authentication);

        const nextPage = payload.page + 1;
        let result
                
        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: true });
        
        if (payload.cleanTable) {
            yield put({type: "CLEAN_ORIGIN_CERTIFICATE_LIST"});
        }

		result = yield call(originCertificateList, payload, token);

		if (result) {
            if (result.items && result.items.length) {
                yield put({
                    type: "SET_ORIGIN_CERTIFICATE_LIST",
                    payload: {
                        list: result.items,
                        hasMore: true,
                        page: nextPage,
                    } 
                });
            } else {                
                yield put({
                    type: "SET_ORIGIN_CERTIFICATE_LIST",
                    payload: {
                        list: result.items,
                        hasMore: false,
                        page: payload.page,
                    }
                });
            }
        }

        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: false });
	} catch (error) {
		log.info(error);
        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: false });
	}
}

function* getOriginCertificateFile({payload}) {
	try {
		const { token } = yield select(state => state.authentication);
        let result

        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: true });

		result = yield call(originCertificateData, payload, token);
        
		if (result) {

            if (result.id) {
                let file
                
                file = yield call(originCertificateFile, payload, token);

                if (file && file.file) {
                    yield put({
                        type: "SET_ORIGIN_CERTIFICATE_FILE",
                        payload: file.file
                    });

                    yield put({
                        type: "SET_NEW_FILE_DETAILS",
                        payload: {
                            id: result.id,
                            orderId: result.pedido,
                            code: result.codigo
                        }
                    })                
                }

            }
        }

        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: false });
	} catch (error) {
		log.info(error);
        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: false });
	}
}

function* uploadOriginCertificateFile({payload}) {
	try {
		const { token } = yield select(state => state.authentication);
        const lang = yield select(state => state.language.name);
        let result

        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: true });

        var base64 = payload.file ? yield convertBase64(payload.file) : ''

        if (payload.isEdit && payload.fileDetails.id) {
            result = yield call(editUploadFile, payload, base64, token);
        } else {
            result = yield call(uploadFile, payload, base64, token);
        }

		if (result) {
            yield put({ 
				type: "SET_ORIGIN_CERTIFICATE_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerSuccess,
					messageType: "toast-success"
            }});
        }

        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: false });
	} catch (error) {        
		log.info(error);
        const lang = yield select(state => state.language.name);

        yield put({ 
            type: "SET_ORIGIN_CERTIFICATE_TOAST", 
            payload: {
                showToast: true,
                message: error.message || messages[lang].registerError,
                messageType: "toast-error"
        }});
        yield put({ type: "SET_IS_LOADING_ORIGIN_CERTIFICATE", payload: false });
	}
}

// //Generator function
export function* originCertificateWatcher() {
    yield takeLatest("GET_ORIGIN_CERTIFICATE_LIST", getOriginCertificateList);
    yield takeLatest("GET_ORIGIN_CERTIFICATE_FILE", getOriginCertificateFile);
    yield takeLatest("UPLOAD_ORIGIN_CERTIFICATE", uploadOriginCertificateFile);
}
